import { Route } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { ReportIssueFormComponent } from './modules/app-service/components/report-issue-form/report-issue-form.component';
import { RegistrationCompleteComponent as RegistrationOrganizationCompleteComponent } from './modules/organization/modules/settings/pages/registration-complete/registration-complete.component';
import { AccessDeniedComponent } from './shared/pages/access-denied/access-denied.component';
import { RegistrationCompleteGuard } from './modules/organization/modules/settings/registration-complete.guard';
import { AuthGuard } from '@auth0/auth0-angular';
import { inject } from '@angular/core';
import { UserService } from './services/user.service';
import { SignUpGuard } from './shared/pages/sign-up/sign-up.guard';
import { APPGUARD } from './guards/app.guard';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadComponent: () => import('app/shared/pages/auth-loading/auth-loading.component').then(c => c.AuthLoadingComponent),
    title: ''
  },
  {
    path: 'login',
    loadComponent: () => import('app/shared/pages/login/login.component').then(c => c.LoginComponent),
    title: 'Login',
    canActivate: [AuthGuard]
  },
  {
    path: 'signout',
    loadComponent: () => import('app/shared/pages/sign-out/sign-out.component').then(c => c.SignOutComponent),
    title: 'Sign Out'
  },
  {
    path: 'signup',
    loadComponent: () => import('app/shared/pages/sign-up/sign-up.component').then(c => c.SignUpComponent),
    title: 'Sign Up',
    canActivate: [SignUpGuard]
  },
  {
    path: 'join',
    loadComponent: () => import('app/modules/invite/pages/invite-join/invite-join.component').then(c => c.InviteJoinComponent),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'company/complete-registration',
        component: RegistrationOrganizationCompleteComponent,
        canActivate: [RegistrationCompleteGuard],
        title: 'Create Organization'
      },
      // {
      //   path: 'user/complete-registration',
      //   component: RegistrationUserCompleteComponent,
      //   canActivate: [RegistrationCompletedGuard],
      //   canDeactivate: [RegistrationCompletedGuard],
      // },
      {
        path: '',
        component: LayoutComponent,
        canActivate: [() => inject(APPGUARD)],
        resolve: [() => inject(NgcCookieConsentService).open()],
        // resolve: [OrganizationOnboardingResolver],
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'dashboard',
          },
          // {
          //   path: 'onboarding',
          //   component: OnboardingComponent,
          //   canActivate: [OnboardingGuard],
          //   title: 'Onboarding'
          // },
          {
            path: 'report-issue-form',
            component: ReportIssueFormComponent
          },
          {
            path: 'user',
            loadChildren: () => import('app/modules/user/user.module').then(m => m.UserModule),
          },
          {
            path: 'organization',
            loadChildren: () => import('app/modules/organization/organization.module').then(m => m.OrganizationModule),
            canActivate: [() => inject(UserService).isOrganizationOwnerGuard$]
          },
          {
            path: 'settings',
            loadChildren: () => import('app/modules/settings/settings.routes').then(r => r.ROUTES),
          },
          {
            path: 'screenshots',
            loadChildren: () => import('app/modules/screenshots/screenshots.routing').then(r => r.ROUTES)
          },
          {
            path: 'tasks',
            loadChildren: () => import('app/modules/task/tasks.routing').then(r => r.ROUTES),
          },
          {
            path: 'reports',
            loadChildren: () => import('app/modules/reports/reports.routing').then(r => r.ROUTES),
          },
          {
            path: 'dashboard',
            loadChildren: () => import('app/modules/dashboards/dashboard.routing').then(r => r.ROUTES),
          },
          {
            path: 'projects', loadChildren: () => import('app/modules/organization/modules/projects/projects.module').then(m => m.ProjectsModule)
          },
          {
            path: 'members',
            loadComponent: () => import('app/modules/organization/modules/people/pages/members/members.component').then(c => c.MembersComponent),
            title: 'Members',
            children: [
              {
                path: ':idMember',
                loadComponent: () => import('app/modules/organization/modules/people/pages/team-member/team-member.component').then(c => c.TeamMemberComponent),
                data: { title: 'Member' },
                // children: [
                //   {
                //     path: 'edit',
                //     loadComponent: () => import('app/modules/organization/modules/people/pages/edit-member/edit-member.component').then(c => c.EditMemberComponent),
                //     title: 'Edit Member',
                //   },

                // ]
              },
            ]
          },
          {
            path: 'members/:idMember/edit',
            loadComponent: () => import('app/modules/organization/modules/people/pages/edit-member/edit-member.component').then(c => c.EditMemberComponent),
            title: 'Edit Member',
          },
          {
            path: 'invites',
            loadComponent: () => import('app/modules/organization/modules/people/pages/invites-list/invites-list.component').then(c => c.InvitesListComponent),
            title: 'Invites',
          },
          {
            path: 'teams',
            loadComponent: () => import('app/modules/organization/modules/people/pages/teams/teams.component').then(c => c.TeamsComponent),
            title: 'Teams',
          },
          {
            path: 'live-work-tracking',
            loadComponent: () => import('app/modules/organization/modules/reports/pages/live-dashboard/pages/live-work-tracking/live-work-tracking.component').then(c => c.LiveWorkTrackingComponent),
            title: 'Live Work Tracking',
            // canActivate: [LiveGuard],
          },
          {
            path: 'integrations',
            loadChildren: () => import('app/modules/organization/modules/integrations/integrations.routing').then(r => r.ROUTES),
            canActivate: [() => inject(UserService).isOrganizationOwnerGuard$],
            canActivateChild: [() => inject(UserService).isOrganizationOwnerGuard$]
          },

          // {
          //   path: 'reports',
          //   loadChildren: () => import('app/modules/organization/modules/reports/reports.module').then(m => m.ReportsModule),
          //   canMatch: [() => {
          //     // console.log('reports canMatch')
          //     const userService = inject(UserService);
          //     const router = inject(Router);
          //     if (userService.userId) {
          //       return userService.isOrganizationOwner$;
          //     } else router.navigateByUrl('/');
          //   }],
          // },
          // {
          //   path: 'user-reports',
          //   loadChildren: () => import('app/modules/user/modules/reports/reports.module').then(m => m.ReportsModule),
          // },
        ]
      },
    ]
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  // 404 & Catch all
  {
    path: '', loadChildren: () => import('app/modules/errors/errors.module').then(m => m.ErrorsModule)
  },
  {
    path: '**',
    redirectTo: 'errors/404-not-found'
  },
];
